import { productConstants } from '../constants';
import { productRequests } from '../../services';
import { handleErrorMessage } from '../../utils';

export const productActions = {}//Objeto agrupador de funciones

productActions.ProductsRemote = () => {
  return dispatch => {
    dispatch(request())//Ejecución de inicialización del "request()"
    productRequests.ProductsRemote()//Ejecución de petición al API
      .then(//Respuesta de promesa
        productData => dispatch(success(productData)),//Respuesta correcta del API
        error => dispatch(failure(handleErrorMessage(error)))//Respuesta erronea del API
      )
  }

  function request() { //Ingresar la petición hacia las API's (Aquí mostrar gif loader)
    return { type: productConstants.PRODUCTSREMOTE_REQUEST }// => carpeta constants => ProductConstants.js
  }

  function success(productData) { //Respuesta correcta de petición
    return { type: productConstants.PRODUCTSREMOTE_SUCCESS, productData } // => carpeta constants => ProductConstants.js
  }

  function failure(error) { //Respuesta errone ade petición (Mostrar modal de cortesía)
    return { type: productConstants.PRODUCTSREMOTE_FAILURE, error } // => carpeta constants => ProductConstants.js
  }
}
///Siguiente paso => Crear reducer